"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PayRecord = /** @class */ (function () {
    function PayRecord() {
    }
    return PayRecord;
}());
exports.PayRecord = PayRecord;
